import { FC } from 'react'

import LoadingButton from '@/components/loading-button'
import { SMSConfiguration } from '@/out/sms'
import useSMSDelete from '@/pages/settings/sms-configuration/twilio/useSMSDelete'
import formatPhoneNumber from '@/util/format-phone-number'
import { Label } from '@/components/ui/label'

type Props = {
  twilio: SMSConfiguration['twilio']
  onRemove: () => void
}

const TwilioDetails: FC<Props> = ({ twilio, onRemove }) => {
  const [remove, { timer }] = useSMSDelete(onRemove)

  return (
    <>
      <div className="mb-6 space-y-3">
        <div className="flex flex-col gap-1 text-left">
          <Label className="text-muted-foreground">Account SID:</Label>
          <span className="text-sm font-medium" data-testid="twilio-account-sid-display">
            {twilio.accountSid}
          </span>
        </div>
        <div className="flex flex-col gap-1 text-left">
          <Label className="text-muted-foreground">Phone Number:</Label>
          <span className="text-sm font-medium" data-testid="twilio-phone-number-display">
            {formatPhoneNumber(twilio.phoneNumber)}
          </span>
        </div>
      </div>
      <LoadingButton
        timer={timer}
        size="sm"
        onClick={remove}
        variant="outline"
        className="hover:bg-destructive hover:text-secondary"
        data-testid="twilio-disconnect-button"
      >
        Disconnect
      </LoadingButton>
    </>
  )
}

export default TwilioDetails
